<div class="help-outer">

    <div class="top-banner">
        <app-header-v1 [presentComponent]="presentComponent"></app-header-v1>
        <div class="landing-container header-navbar">
                    <div class="help-text">
                        <h4>Help Center</h4>
                        <p>Get instant answers by watching our videos & tailor <br>made mini-guides.</p>
                    </div> 
        </div>
    </div>
    <div class="tab-outer">
        <div class="landing-container">
            <div class="header-tabs">
                <ul>
                    <li (click)="setActiveTab(0)" [ngClass]="{'workflow-active': activeIndex === 0}">
                        <div class="workflow-outer">
                            <img src="../../assets/images/parking-workflow.svg" alt="Parking workflow"/>
                            <p>Driver Mobile Application Tutorials</p>
                        </div>
                    </li>
                    <li (click)="setActiveTab(1)" [ngClass]="{'workflow-active': activeIndex === 1}">
                        <div class="workflow-outer">
                            <img src="../../assets/images/driver-flow.svg" alt="Driver flow"/>
                            <p>Driver Web Application Tutorials</p>
                        </div>
                    </li>
                    <li (click)="setActiveTab(2)" [ngClass]="{'workflow-active': activeIndex === 2}">
                        <div class="workflow-outer">
                            <img src="../../assets/images/faq-flow.svg" alt="FAQ flow"/>
                            <p>Frequently Asked Questions</p>
                        </div>
                    </li>
                </ul>
            </div>
            <div *ngIf="driverWeb" class="driver-workflow-outer">
                <div class="workflow-heading">
                    <h5>Driver Web Application Tutorials</h5>
                </div>
                <div class="grid">
                    <div *ngFor="let item of driverWebVedioLists" class="col-6 lg:col-3">
                        <div class="box-border">
                            <div class="box-img">
                                <h5>{{item.title}}</h5>
                            </div>
                            <div class="pdf-outer">
                                <div class="play-outer" (click)="showDialog(item.vedioUrl)">
                                    <img src="../../assets/images/play-icon.svg" alt="Play"/>
                                    <p>Play</p>
                                </div>
                                <div *ngIf="item.pdfLink != ''" class="download-outer">
                                    <a href="{{item.pdfLink}}" target="_blank" rel="noopener">
                                        <p>Download</p>
                                        <img src="../../assets/images/pdf-icon.svg" alt="Download"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="driverMobile" class="driver-workflow-outer parking-manager-outer">
                <div class="workflow-heading">
                    <h5>Driver Mobile Application Tutorials</h5>
                </div>
                <div class="grid">
                    <div *ngFor="let item of driverMobileVedioLists" class="col-6 lg:col-3">
                        <div class="box-border">
                            <div class="box-img">
                                <h5>{{item.title}}</h5>
                            </div>
                            <div class="pdf-outer">
                                <div class="play-outer" (click)="showDialog(item.vedioUrl)">
                                    <img src="../../assets/images/play-icon.svg" alt="Play"/>
                                    <p>Play</p>
                                </div>
                                <div *ngIf="item.pdfLink != ''" class="download-outer">
                                    <a href="{{item.pdfLink}}" target="_blank" rel="noopener">
                                        <p>Download</p>
                                        <img src="../../assets/images/pdf-icon.svg" alt="Download" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="faq" class="faq-outer">
                <div class="workflow-heading">
                    <h5>Frequently Asked Questions</h5>
                </div>

                <div class="faq-main">
                    <div class="faq-outer">
                        <div class="faq-information">
                            <p (click)="setActiveCategoryLink(0)"
                                [ngClass]="{'icon-active': categoryActiveIndex === 0}">
                                <span class="icon-main">
                                    <div class="my-icon custom-myicon" aria-label="My icon"
                                        [inlineSVG]=" categoryActiveIndex === 0 ? 'assets/images/sign-up-iconwhite.svg' : 'assets/images/sign-up-icon.svg'">
                                    </div>
                                </span><span>Signup</span>
                            </p>
                            <p (click)="setActiveCategoryLink(1)"
                                [ngClass]="{'icon-active': categoryActiveIndex === 1}">
                                <span class="icon-main">
                                    <div class="my-icon custom-myicon" aria-label="My icon"
                                        [inlineSVG]=" categoryActiveIndex === 1 ? 'assets/images/reserve-icon-white.svg' : 'assets/images/reserve-icon.svg'">
                                    </div>
                                </span><span>Reserve spot</span>
                            </p>
                            <p (click)="setActiveCategoryLink(2)"
                                [ngClass]="{'icon-active': categoryActiveIndex === 2}">
                                <span class="icon-main">
                                    <div class="my-icon custom-myicon" aria-label="My icon"
                                        [inlineSVG]=" categoryActiveIndex === 2 ? 'assets/images/offerwhite-icon.svg' : 'assets/images/offer-icon.svg'">
                                    </div>

                                </span><span>Offers & promo code</span>
                            </p>
                            <p (click)="setActiveCategoryLink(3)"
                                [ngClass]="{'icon-active': categoryActiveIndex === 3}">
                                <span class="icon-main">
                                    <div class="my-icon custom-myicon" aria-label="My icon"
                                        [inlineSVG]=" categoryActiveIndex === 3 ? 'assets/images/payment-icon-white.svg' : 'assets/images/payment-icon.svg'">
                                    </div>

                                </span><span>Payments</span>
                            </p>
                            <p (click)="setActiveCategoryLink(4)"
                                [ngClass]="{'icon-active': categoryActiveIndex === 4}">
                                <span class="icon-main">
                                    <div class="my-icon custom-myicon" aria-label="My icon"
                                        [inlineSVG]=" categoryActiveIndex === 4 ? 'assets/images/cancle-icon-white.svg' : 'assets/images/cancle-icon.svg'">
                                    </div>

                                </span><span>Cancellation</span>
                            </p>
                            <p (click)="setActiveCategoryLink(5)"
                                [ngClass]="{'icon-active': categoryActiveIndex === 5}">
                                <span class="icon-main">
                                    <div class="my-icon custom-myicon" aria-label="My icon"
                                        [inlineSVG]=" categoryActiveIndex === 5 ? 'assets/images/credit-icon-white.svg' : 'assets/images/credit-icon.svg'">
                                    </div>
                                </span><span>Trucklots credits</span>
                            </p>
                            <p (click)="setActiveCategoryLink(6)"
                                [ngClass]="{'icon-active': categoryActiveIndex === 6}">
                                <span class="icon-main">
                                    <div class="my-icon custom-myicon" aria-label="My icon"
                                        [inlineSVG]=" categoryActiveIndex === 6 ? 'assets/images/account-icon-white.svg' : 'assets/images/account-icon.svg'">
                                    </div>
                                </span>
                                <span>Accounts</span>
                            </p>

                        </div>
                    </div>
                    <div class="faq-accordtion">
                        <div class="card flex justify-content-center">
                            <p-accordion *ngIf="signup" class="w-full custom-accordion" expandIcon="pi pi-plus"
                                collapseIcon="pi pi-minus">
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How do I sign up with Trucklots as a driver? </h5>
                                    </ng-template>
                                    <p class="m-0">
                                        Tap on the “Sign In” button from the splash screen, you get redirected to “Sign
                                        In” screen where you will get the option to sign up.  On the sign-up page, enter
                                        the relevant information to create your account such as full name, email
                                        address, password and profile picture. There you also have option to sign up
                                        using a promo code and avail it’s benefit while creating a booking.
                                    </p>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How do I use a promotion code while signing up?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        On the sign-up page, there is a promo code field. When the driver clicks on it,
                                        a popup window will appear on their screen. The driver needs to enter the promo
                                        code and press the apply button. If the promo code is valid, it will be applied
                                        to the current registration. Otherwise, the app will display an invalid coupon
                                        code message to the driver.
                                    </p>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How do I get verification codes?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        At the time of sign-up, the driver adds their email ID and mobile number. When
                                        the basic details of the driver are submitted to Trucklots, the app sends a
                                        verification code to the email ID and phone number provided during sign-up for
                                        the validation process.
                                    </p>
                                </p-accordionTab>
                            </p-accordion>
                            <p-accordion *ngIf="reserveSpot" class="w-full custom-accordion" expandIcon="pi pi-plus"
                                collapseIcon="pi pi-minus">
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How do I search for a parking lot?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        After signing up or opening the app, Trucklots will prompt you with a Filter
                                        screen. Here, you'll select a vehicle type and set a date and time filter to
                                        receive relevant search results on the next screen. Click on "Search Parking" to
                                        proceed. You can then enter a location, such as "Realize at Calhoun," or any
                                        street address you wish to search for. Simply type your desired location into
                                        the search parking text area. If you're looking for a specific place, like Clay
                                        Parking, Trucklots will display potential parking lots matching your search
                                        criteria.
                                    </p>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How do I reserve a parking spot?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        All the available parking lot marker showcase on Google map, tap on the desired
                                        marker and it will take you to quick view tray showing you a precise summary of
                                        parking lot. The map will show estimated distance and time of the selected
                                        parking lot from your current location using a polyline. Tap on “Book Now” to
                                        proceed with booking your spot or tap on “More Details” button to view details
                                        of the selected parking lot. "More Details” button will redirect you to parking
                                        details screen with information such as Street View, Parking photos, Facilities,
                                        Reviews and Ratings, About Parking lot and Manager contact links. Tap on the
                                        “Book Your Spot” button to proceed to the Booking Details screen. Tapping on
                                        Confirm Booking will take you to Booking Summary screen where you can review
                                        your booking details including the total price to pay.
                                    </p>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How do I create a one-time booking?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        On the Booking Details screen, select the "One Time" booking option. Then, you
                                        can enter or edit the arrival and departure date and time, and specify if you
                                        are carrying any hazardous load. Before confirming the booking, thoroughly read
                                        the Parking Lot Instructions from the provided link and agree to proceed
                                        further. Tapping on "Confirm Booking" will take you to the Booking Summary
                                        screen, where you can review your booking details, including the total price to
                                        pay. You will then be presented with the payment options supported by the
                                        Trucklots platform, such as payment by card or US Bank Account payment.
                                    </p>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How do I create a recurring parking booking?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        On the Booking Details screen, select the “Recurring” booking option. Then, you
                                        can enter or edit Arrival Date and Time, set the desired Booking frequency to
                                        Monthly enter vehicle details and specify if you are carrying any Hazardous
                                        Load. Before confirming the Booking, thoroughly read the Parking Lot
                                        Instructions from the link and agree to it to proceed further. Tapping on
                                        Confirm Booking will take you to Booking Summary screen where you can review
                                        your booking details including the total price to pay.  You will be presented
                                        with the Payment options supported by Trucklots platform i.e. Payment by Card,
                                        US Bank Account Payment.
                                    </p>
                                </p-accordionTab>
                            </p-accordion>
                            <p-accordion *ngIf="promoCode" class="w-full custom-accordion" expandIcon="pi pi-plus"
                                collapseIcon="pi pi-minus">
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>Where can I find offers?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        In the web application, locate the "Offers" screen within the side menu bar. For
                                        mobile users, access it through the "My Profile" section. On the Offers screen,
                                        drivers can view their available, expired, and redeemed offers.
                                    </p>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How do I apply a promotion code?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        On the Booking Summary screen, tap on Offers & Benefits to view the list of
                                        available offers. Choose the required offer that will be applicable to the
                                        current booking. This also provides an interface to type a promo code and apply
                                        that offer.
                                    </p>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>Why are promotion codes not working?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        There could be several reasons for not being able to apply a promo code,
                                        including:
                                    </p>
                                    <ul>
                                        <li>
                                            Entering the wrong promo code.
                                        </li>
                                        <li>
                                            The promo code being applicable only under specific conditions.
                                        </li>
                                        <li>
                                            The promo code has expired.
                                        </li>
                                    </ul>
                                </p-accordionTab>
                            </p-accordion>
                            <p-accordion *ngIf="payments" class="w-full custom-accordion" expandIcon="pi pi-plus"
                                collapseIcon="pi pi-minus">
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How do I make a payment with a credit/debit card?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        On the Booking Summary screen, select the “Card” payment method and press the
                                        “Pay Now” button. The app will redirect you to the payment screen where you can
                                        enter your card number, expiry date, CVC number, and other required details.
                                        After filling in the card information, click the "Pay" button. The system will
                                        then validate your card and process the payment.
                                    </p>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How do I make a payment through a US bank account?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        On the Booking Summary screen, select the “US Bank Account” payment method and
                                        press the “Pay Now” button. The app will redirect you to the payment screen,
                                        where you can enter the required bank account information, including the routing
                                        and account numbers. After entering the details, press the “Pay” button. The
                                        system will then process the payment through the ACH network, transferring funds
                                        from your bank account to the recipient's account.
                                    </p>
                                </p-accordionTab>
                            </p-accordion>
                            <p-accordion *ngIf="cancellation" class="w-full custom-accordion" expandIcon="pi pi-plus"
                                collapseIcon="pi pi-minus">
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How do I cancel my booking?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        Tap on “Bookings” in the bottom navigation bar for mobile or in the side
                                        menu for the web app. Within the bookings section, switch to the “Upcoming”
                                        tab. Tap on “Cancel Booking” to initiate the cancellation process for a specific
                                        booking. You will be prompted with two options for the mode of refund. The
                                        first option will refund the amount to your original payment method, while the
                                        second method will credit the amount as points to your Trucklots account. Click
                                        on the confirm button to cancel the booking and process the refund to the
                                        selected payment source.
                                    </p>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How do I cancel a recurring booking?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        Tap on “Bookings” in the bottom navigation bar for mobile or in the side
                                        menu for the web app. Within the bookings section, switch to the “Current”
                                        tab. Tap on “Cancel Subscription” to initiate the subscription cancellation
                                        process for a particular recurring booking. By selecting this option, your
                                        subscription will be discontinued starting with the next booking.
                                    </p>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>What is the refund timeline?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        The refund timeline for card and ACH payments in the US can vary depending on
                                        several factors, such as the policies of the payment processor and the financial
                                        institution involved. Generally, refunds for card payments typically take 3-5
                                        business days to appear back in your account, while ACH payments may take
                                        longer, ranging from 5-10 business days. However, these timelines can vary, so
                                        it's advisable to check with your bank or payment provider for specific details
                                        regarding refund processing times.
                                    </p>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>Where do I receive my refund amount?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        The following are the sources to receive the refund: -
                                    </p>
                                    <ul>
                                        <li> Refund amounts for card payments are usually credited back to the original
                                            card
                                            used for the transaction.
                                        </li>
                                        <li>
                                            ACH payments are commonly deposited directly into the bank account linked to
                                            the
                                            payment.
                                        </li>
                                        <li>
                                            Additionally, you have the option to convert the refund into credit points,
                                            visible in the profile section, which can be used for future bookings. Each
                                            point is equivalent to 1 USD.
                                        </li>
                                    </ul>
                                </p-accordionTab>
                            </p-accordion>
                            <p-accordion *ngIf="credits" class="w-full custom-accordion" expandIcon="pi pi-plus"
                                collapseIcon="pi pi-minus">
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>What are credit points?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        Credit points are a form of virtual currency that can be earned, accumulated,
                                        and used for booking. You have the option to convert the refund into credit
                                        points, visible in the profile section, which can be used for future bookings.
                                        Each point is equivalent to 1 USD.
                                    </p>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How do I earn credit points?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        When cancelling a booking, Trucklots offers the option to refund the entire
                                        amount to your original payment source or convert the refund into credit points.
                                        By selecting credit points, all refunded money is transferred to your credit
                                        balance, which can then be used for future bookings.
                                    </p>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How do I utilize credit points?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        Tap on the Book Your Spot button to proceed to the Booking Details screen.
                                        Select your preferred booking type and enter the required details to proceed
                                        further. Tapping on Confirm Booking will take you to Booking Summary screen
                                        where you can review your booking details including the total price to pay. If
                                        you have credits added to your account you will get option to use these credits
                                        for this particular booking. Tap on Pay from credits to implement the
                                        credits to the booking and get updated booking summary.
                                    </p>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How can I check the credit points in my account?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        You may review your credit points within the “My Profile” section. They will be
                                        adjusted accordingly if utilized during booking or when opting for credit points
                                        during booking cancellation.
                                    </p>
                                </p-accordionTab>
                            </p-accordion>
                            <p-accordion *ngIf="accounts" class="w-full custom-accordion" expandIcon="pi pi-plus"
                                collapseIcon="pi pi-minus">
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How to change my current password?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        To change your current password, navigate to “My Profile” section. Then, locate
                                        the option to Change Password and follow the prompts to set a new password.
                                    </p>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How to find notifications?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        Click on the bell icon on top right corner of the screen to view the list of
                                        notifications. Tap on any of the notifications from the listing to redirect the
                                        user to the booking details. 
                                    </p>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How to delete my account?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        To delete your account, access the profile section. Look for the option to
                                        delete your account. Follow the provided instructions to complete the process.
                                        Keep in mind that deleting your account will permanently remove all associated
                                        data and cannot be undone.
                                    </p>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How to recover my password?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        To recover your password, navigate to the login page and locate the Forgot
                                        Password option. Follow the provided instructions, which typically involve
                                        entering your email address associated with your account. An email with
                                        instructions for resetting your password will then be sent to you. Follow the
                                        link in the email to set a new password for your account.
                                    </p>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        <h5>How to update my profile information?</h5>
                                    </ng-template>
                                    <p class="m-0">
                                        To update your profile information, access the profile section within your
                                        account. From there, you can edit various details such as your name, contact
                                        information, and profile picture as well. Make sure to save your changes after
                                        updating your profile.
                                    </p>
                                </p-accordionTab>
                            </p-accordion>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</div>
<div class="copy-right">
    <div class="landing-container">
        <div class="copy-right-inner">
            <a href="mailto:support@trucklots.com">support@trucklots.com</a>
            <p>Copyright © 2024. All rights reserved by Trucklots.</p>
        </div>
    </div>
</div>

<p-dialog header="Header" [(visible)]="display" [modal]="true" [style]="{ width: '50vw' }">
    <div class="video-outer">
        <div class="image-cross" (click)="hideDialog()">
            <img src="assets/images/export-close.svg" alt="">
        </div>
        <video #videoPlayer *ngIf="selectedVideo" class="responsive-video" controls>
            <source [src]="selectedVideo" type="video/mp4">
            Your browser does not support the video tag.
        </video>
    </div>
</p-dialog>